import utils from '~common/js/utils';
import store from '~system/vuex';

function getHomePageId(isLoggedIn) {
	let homepageId = utils.getConfigurationValue('CFG_CMP_HOME_PAGE_ID');

	if (!isLoggedIn) { // 로그인 상태가 아닌 경우
		if (aiccUtils.urlUtil.getCcUrl()) { // pathname 형식이 정상적인 경우, 로그인 화면이 default
			homepageId = 'Login';

		} else { // pathname 형식이 비정상적인 경우, 안내 화면이 default
			homepageId = 'Welcome';
		}

	} else if (store.state.policyAgreeYn === 'N') {
		//약관동의 페이지
		homepageId = 'PGE_AIM_00005';
	} else {
		//테넌트 처리 상태
		//A:수신완료, B:SCHEMA 생성완료, C:대표계정 생성완료, D:domain입력완료, E:번호생성완료
		//C 까지는 Mytrial 프로비저닝, iDaaS프로비저닝 통해서 진행됨. front에서는 domain입력과 070 번호 입력 진행
		if (store.state.tenantStatus === 'C') {
		//domain입력 화면
		homepageId = 'PGE_AIM_00002';
		} else if (store.state.tenantStatus === 'D') {
		//070 번호 입력화면
		homepageId = 'PGE_AIM_00003';
		}
	}

	return homepageId;
}
  
export default getHomePageId;
  